export const DEFAULT_WEB_FAVICON_URL = '/favicon.ico'

function parseRecord(value) {
  if (typeof value === 'string') {
    try {
      return parseRecord(JSON.parse(value))
    }
    catch {
      return {}
    }
  }

  return value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : {}
}

function firstUrl(...values) {
  for (const value of values) {
    const url = String(value || '').trim()
    if (url) {
      return url
    }
  }

  return ''
}

function getOtherJson(shopInfo) {
  const followDataCandidates = [
    shopInfo.offiaccountFollowData,
    shopInfo.offiaccountFollowUrlData,
    shopInfo.offiaccountFollowUrl,
  ]

  for (const followDataValue of followDataCandidates) {
    const followData = parseRecord(followDataValue)
    const otherJson = parseRecord(followData.otherJson)
    if (Object.keys(otherJson).length) {
      return otherJson
    }
  }

  const directCandidates = [
    shopInfo.otherJson,
    parseRecord(shopInfo.storePageInfo).otherJson,
    shopInfo.storePageInfo,
  ]

  for (const candidate of directCandidates) {
    const otherJson = parseRecord(candidate)
    if (Object.keys(otherJson).length) {
      return otherJson
    }
  }

  return {}
}

function getH5MobileBaseConfig(otherJson) {
  const mobileBaseConfig = parseRecord(otherJson.mobileBaseConfig)
  const legacyConfig = Object.fromEntries(
    Object.entries(mobileBaseConfig).filter(
      ([key]) => !['common', 'h5', 'app'].includes(key),
    ),
  )

  return {
    ...legacyConfig,
    ...parseRecord(mobileBaseConfig.common),
    ...parseRecord(mobileBaseConfig.h5),
  }
}

export function resolveShopFaviconUrl(shopInfoValue) {
  const shopInfo = parseRecord(shopInfoValue)
  const otherJson = getOtherJson(shopInfo)
  const mobileBaseConfig = getH5MobileBaseConfig(otherJson)
  const appInfoPage = parseRecord(otherJson.appInfoPage)
  const reactAppConfig = parseRecord(otherJson.reactAppConfig)
  const faviconUrl = firstUrl(
    mobileBaseConfig.faviconUrl,
    otherJson.faviconUrl,
    reactAppConfig.faviconUrl,
    appInfoPage.faviconUrl,
    otherJson.mobile_SITE_LOGO,
    otherJson.SITE_ICON,
    otherJson.pc_SITE_ICON,
    appInfoPage.appLogo,
    mobileBaseConfig.homeIconUrl,
    otherJson.homeIconUrl,
    shopInfo.mobile_SITE_LOGO,
    shopInfo.SITE_ICON,
    shopInfo.pc_SITE_ICON,
    shopInfo.faviconUrl,
    shopInfo.logoUrl,
    shopInfo.shopLogo,
    shopInfo.logo,
  )

  return faviconUrl || DEFAULT_WEB_FAVICON_URL
}
